import { render, staticRenderFns } from "./InitSample.vue?vue&type=template&id=a5ba6996&scoped=true"
import script from "./InitSample.vue?vue&type=script&lang=js"
export * from "./InitSample.vue?vue&type=script&lang=js"
import style0 from "./InitSample.vue?vue&type=style&index=0&id=a5ba6996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ba6996",
  null
  
)

export default component.exports